"use client"

import { ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function TextBoldL({
  children,
  className = "",
}: Props) {
  return (
    <p
      className={`
        text-base
        font-bold
        leading-6
        normal-case
        text-sm
        tracking-normal
        ${className}
      `}
    >
      {children}
    </p>
  )
}